export default __webpack_public_path__ + "static/media/roadmap.9814b6c8.png";